import { isUrl } from '@udecode/plate';

const imageExtensions = new Set([
    '3dv',
    'ai',
    'amf',
    'art',
    'art',
    'ase',
    'awg',
    'blp',
    'bmp',
    'bw',
    'bw',
    'cd5',
    'cdr',
    'cgm',
    'cit',
    'cmx',
    'cpt',
    'cr2',
    'cur',
    'cut',
    'dds',
    'dib',
    'djvu',
    'dxf',
    'e2d',
    'ecw',
    'egt',
    'egt',
    'emf',
    'eps',
    'exif',
    'fs',
    'gbr',
    'gif',
    'gpl',
    'grf',
    'hdp',
    'icns',
    'ico',
    'iff',
    'iff',
    'int',
    'int',
    'inta',
    'jfif',
    'jng',
    'jp2',
    'jpeg',
    'jpg',
    'jps',
    'jxr',
    'lbm',
    'lbm',
    'liff',
    'max',
    'miff',
    'mng',
    'msp',
    'nitf',
    'nrrd',
    'odg',
    'ota',
    'pam',
    'pbm',
    'pc1',
    'pc2',
    'pc3',
    'pcf',
    'pct',
    'pcx',
    'pcx',
    'pdd',
    'pdn',
    'pgf',
    'pgm',
    'PI1',
    'PI2',
    'PI3',
    'pict',
    'png',
    'pnm',
    'pns',
    'ppm',
    'psb',
    'psd',
    'psp',
    'px',
    'pxm',
    'pxr',
    'qfx',
    'ras',
    'raw',
    'rgb',
    'rgb',
    'rgba',
    'rle',
    'sct',
    'sgi',
    'sgi',
    'sid',
    'stl',
    'sun',
    'svg',
    'sxd',
    'tga',
    'tga',
    'tif',
    'tiff',
    'v2d',
    'vnd',
    'vrml',
    'vtf',
    'wdp',
    'webp',
    'wmf',
    'x3d',
    'xar',
    'xbm',
    'xcf',
    'xpm',
]);

export const isImageUrl = (url: string) => {
    if (!isUrl(url)) return false;

    const ext = new URL(url).pathname.split('.').pop() as string;

    return imageExtensions.has(ext);
};
